"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var Scale_less_1 = __importDefault(require("./Scale.less"));
var onKeyDown = function (event) {
    // Keep arrow keys on the range instead of spatial navigation.
    if (event.key.startsWith('Arrow'))
        event.stopPropagation();
};
var Scale = function (_a) {
    var min = _a.min, max = _a.max, step = _a.step, options = _a.options, value = _a.value, tabIndex = _a.tabIndex, onChange = _a.onChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(value), preview = _b[0], setPreview = _b[1];
    var inputRef = (0, react_1.useRef)(null);
    var dragging = (0, react_1.useRef)(null);
    var onTickClick = (0, react_1.useCallback)(function (event) {
        onChange(Number(event.currentTarget.value));
    }, [onChange]);
    var onPointerDown = (0, react_1.useCallback)(function (event) {
        if (event.isPrimary && event.button === 0)
            dragging.current = event.pointerId;
    }, []);
    var onInputChange = (0, react_1.useCallback)(function (event) {
        var next = event.currentTarget.valueAsNumber;
        setPreview(next);
        // Zooming during a drag moves the slider underneath the pointer.
        if (dragging.current === null)
            onChange(next);
    }, [onChange]);
    (0, react_1.useEffect)(function () {
        setPreview(value);
    }, [value]);
    (0, react_1.useEffect)(function () {
        var finishDrag = function (event) {
            if (dragging.current !== event.pointerId || !inputRef.current)
                return;
            dragging.current = null;
            onChange(inputRef.current.valueAsNumber);
        };
        var cancelDrag = function () {
            if (dragging.current === null)
                return;
            dragging.current = null;
            setPreview(value);
        };
        // Let the native range own pointer capture; taking it breaks WebKit dragging.
        document.addEventListener('pointerup', finishDrag, true);
        document.addEventListener('pointercancel', cancelDrag, true);
        window.addEventListener('blur', cancelDrag);
        return function () {
            document.removeEventListener('pointerup', finishDrag, true);
            document.removeEventListener('pointercancel', cancelDrag, true);
            window.removeEventListener('blur', cancelDrag);
        };
    }, [value, onChange]);
    return (react_1.default.createElement("div", { className: Scale_less_1.default['scale'] },
        react_1.default.createElement("div", { className: Scale_less_1.default['ticks'], style: { gridTemplateColumns: "repeat(".concat(options.length, ", 1fr)") } }, options.map(function (tick) {
            var _a;
            return (react_1.default.createElement("button", { type: 'button', value: tick, className: (0, classnames_1.default)(Scale_less_1.default['label'], (_a = {}, _a[Scale_less_1.default['active']] = preview === tick, _a)), key: tick, "aria-pressed": preview === tick, onClick: onTickClick },
                tick,
                "%"));
        })),
        react_1.default.createElement("input", { ref: inputRef, type: 'range', tabIndex: tabIndex, "aria-label": t('SETTINGS_UI_ZOOM'), "aria-valuetext": "".concat(preview, "%"), value: preview, min: min, max: max, step: step, onKeyDown: onKeyDown, onPointerDown: onPointerDown, onChange: onInputChange })));
};
exports.default = Scale;
